<template>
  <div>
    <LoadingState
      v-if="loading"
      :loading="loading"
    />
    <v-container
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
        class="mt-4"
      >
        <v-toolbar
          flat
          color="transparent"
          class="mb-4 mt-4"
          height="20px"
        >
          <v-btn
            icon
            class="text--secondary"
            @click="goBack"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <span class="text-capitalize subheading text--secondary">
            {{ $t('Settings') }}
          </span>
        </v-toolbar>
        <v-flex xs12>
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              md4
              offset-md1
            >
              <h3 class="title font-weight-regular pt-3">
                {{ $t('Payment methods') }}
              </h3>
              <span
                class="caption"
              >{{ $t('List of available system payment methods.') }}</span>

              <v-layout wrap>
                <v-flex
                  xs12
                  px-0>
                  <v-btn
                    @click="selectMethod()"
                  >
                    {{ $t('Add payment method') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <v-card
                flat
                class="pa-3"
              >
                <PaymentList
                  :methods="methods"
                  @selectMethod="selectMethod"
                />
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <template
      v-if="dialog"
    >
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <PaymentMethodForm
            v-if="method"
            :method="method"
            @setPaymentData="setPaymentData"
          />
          <template v-else>
            <v-card-title />
            <loading-state
              :loading="true"
            />
          </template>
          <v-card-actions>
            <v-btn
              v-if="canDelete()"
              color="error"
              flat
              small
              @click="deletePaymentMethod"
            >
              {{ $t('Delete') }}
            </v-btn>

            <v-spacer />
            <v-btn
              color="darken-1"
              flat
              small
              @click="closePaymentMethodDialog"
            >
              {{ $t('Close') }}
            </v-btn>
            <v-btn
              :disabled="!schema"
              color="primary darken-1"
              flat
              small
              @click="savePaymentMethod"
            >
              {{ $t('Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import LoadingState from '@/components/LoadingState'
import PaymentList from '@/modules/Settings/components/Payments/PaymentList'
import PaymentMethodForm from '@/modules/Settings/components/Payments/PaymentMethodForm'
import PaymentMethodsService from '@/modules/Settings/service'

export default {
  name: 'SettingsPayment',

  components: {
    LoadingState,
    PaymentList,
    PaymentMethodForm
  },

  data () {
    return {
      dialog: false,
      loading: false,
      methods: [],
      schema: null,
      sensitiveErrorFields: null,
      method: null
    }
  },

  async created () {
    this.setMethods()
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'settings' })
    },

    async setMethods () {
      this.methods = await PaymentMethodsService.loadPaymentMethods()
    },

    async selectMethod (method) {
      if (!method) {
        this.method = this.$http.make('paymentMethods', {
          code: '',
          integrated: false
        })
        this.dialog = true
        return
      }

      this.method = await this.$http.make('paymentMethods').find(method.id)
      this.dialog = true
    },

    setPaymentData (data) {
      Object.keys(data.schema).forEach(attr => {
        if (!this.method.hasOwnProperty(attr)) {
          this.method.defineAttrs(attr)
        }
      })

      this.schema = data.schema
      this.sensitiveErrorFields = data.sensitiveErrorFields
    },

    async savePaymentMethod () {
      const payload = this.method.payload()

      const method = await this.$http.make('paymentMethods', payload)
      method.save()
        .then(() => {
          this.closePaymentMethodDialog()
          PaymentMethodsService.loadPaymentMethods().then(res => {
            this.methods = res
          })

          this.$toast.success(this.$t(`Payment method updated`))
        })
        .catch(e => {
          this.$vuetify.goTo(0)
          this.cleanErrors(method.errors)
          this.method.errors = [...method.errors]
          method.errors.map(error => {
            this.$toast.error(this.$t(error.message.join('\n')))
          })
        })
    },

    deletePaymentMethod () {
      this.method.delete().then(() => {
        this.closePaymentMethodDialog()
        PaymentMethodsService.loadPaymentMethods().then(res => {
          this.methods = res
        })

        this.$toast.success(this.$t(`Payment method deleted`))
      }).catch(e => {
        this.$toast.error(e.message)
      })
    },

    canDelete () {
      return this.method && this.method.isOffline() && !this.method.hasOwnProperty('account_number')
    },

    async closePaymentMethodDialog () {
      this.dialog = false
      this.schema = null
      this.sensitiveErrorFields = null
    },

    cleanErrors (errors) {
      errors.map(error => {
        error.message = error.message.map(message => {
          if (this.sensitiveErrorFields) {
            let field = error.field.split('.')[2]
            let sensitiveField = this.sensitiveErrorFields[field]
            if (sensitiveField) {
              message = message.replace(sensitiveField, error.field.split('.')[2])
            }
          }
          message = message.replace(error.field, 'field')
          return message
        })
      })
    }
  }
}
</script>
